import { toast } from "react-toastify";
import {
  fetchUpdateItemFailure,
  fetchUpdateItemSuccess,
} from "./reducer";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";
import { UPDATE_ITEM } from "../../constants/constants";

export const updateItem =
  (jsonObj, itemId, setLoading, callBack = () => {}) =>
  async (dispatch) => {
    setLoading(true);

    await determineBaseUrlAndPerformApiCall(
      UPDATE_ITEM(itemId),
      "PUT",
      jsonObj
    )
      .then((response) => {
        if (response.error) {
          dispatch(fetchUpdateItemFailure(response.error.message));
          toast.error(response.error.message);
          callBack();
        } else {
          dispatch(fetchUpdateItemSuccess(response));
          dispatch(setSuccessMessage(true));
          toast.success("Product updated successfully");
          callBack();
        }
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  };